import React, {Fragment, useState, useEffect} from 'react'
import axios from 'axios';
import { Title, HeaderList, Cardlist,Container,Subtitle,Card } from './styles'
import globals from 'react-global-configuration';
import {PatrocinadorItem} from  '../PatrocinadorItem'

export const ListaPatrocinadores = (props) => { 
    
    const _URL_REST = globals.get('_URL_REST');
    

    const [data, setData] = useState(null);
    const [hasInCategoria, setHasInCategoria] = useState(false);
    
    

    const fetchData = async () => {
        const result = await axios(
            `${_URL_REST}/getgrupospatrocinadores/${props.idevento}`,
        );
        setData(result.data)
    };
  
    useEffect(() => {
        fetchData();
    },[]);

    if (!data) {
        return <div></div>  
    }

    
    return (
        <Fragment>
               
                {
                    data
                    .map(item => 
                        <Container key={item.id}>
                            <HeaderList>
                                <Title>{item.nombre}</Title>
                            </HeaderList>
                            <Cardlist>
                                <PatrocinadorItem grupo={item.id} />
                            </Cardlist>

                        </Container>
                    )
                }
               
           
        </Fragment>
    )
}
